import { render } from "./CardThirteen.vue?vue&type=template&id=2b591004"
import script from "./CardThirteen.vue?vue&type=script&lang=js"
export * from "./CardThirteen.vue?vue&type=script&lang=js"

import "./CardThirteen.vue?vue&type=style&index=0&id=2b591004&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__